import React, { useContext, useEffect, useState } from "react";
import CustomButton from "../CustomButton";
import { OrganizationContext } from "../../contexts/OrganizationContextProvider";
import ShortTextInput from "../Inputs/ShortTextInput";
import RichTextEditor from "../texts/RichTextEditor";
import { createRisk, getTasks } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import { useFormik } from "formik";
import ModalUI from "../ui/ModalUI";
import TagDropdownInput from "../buttons/TagDropdownInput";
import { riskValidationSchema } from "../../utils/validations";
import CustomTemplateDropdown from "../Inputs/CustomTemplateDropdown";
import SelectRiskTemplateModal from "./SelectRiskTemplateModal";
import AddUpdateRiskTemplateModal from "./AddUpdateRiskTemplateModal";
import { HiOutlineDotsHorizontal } from 'react-icons/hi';

// from_goal ---> prop use for checking if the risk is added after adding a goal
function AddNewRisk({ show, handleClose, refresh, task, from_goal,workStreamId }) {
  return (
    <ModalUI show={show} handleClose={handleClose} title="Add New Risk" >
      <AddNewRiskForm
        handleRiskClose={handleClose}
        refresh={refresh}
        task_id={task?.id} // only pass task_id if the risk is added from a goal
        from_goal={from_goal}
        task = {task}
        workStreamId={workStreamId} // pass workStream_Id if needed
      />
    </ModalUI>
  );
}

export default AddNewRisk;


// from_goal ---> prop use for checking if the risk is added after adding a goal
// then hide the goal field
function AddNewRiskForm({ handleRiskClose, task_id, refresh, from_goal, task, workStreamId }) {
  const [tasks, setTasks] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const { data: organization } = useContext(OrganizationContext);
  const [showAddTemplateModal, setShowAddTemplateModal] = useState(false);
  const [showSelectTemplateModal, setShowSelectTemplateModal] = useState(false);
  console.log("workStream_Id", workStreamId);
    // Effect to update task_ids when task_id changes
    useEffect(() => {
      if (task_id) {
        formik.setFieldValue("task_ids", [task_id]);
      }
    }, [task_id]);

  // Formik hook
  const formik = useFormik({
    initialValues: {
      title: "",
      task_ids: task_id ? [task_id] :  tasks?.map(task => task.id) || [],
      description: "",
    },
    validationSchema: riskValidationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      console.log("values", values);
      setSubmitting(true);
      try {
        // Create a new risk with the form data
        const response = await createRisk({
          title: values.title,
          description: values.description,
          task_ids: values.task_ids,
        });

        if (response.status === 201) {
          showToast("Risk added successfully", "success");
          if (!from_goal) refresh();
          handleRiskClose();
        } else {
          showToast(response.message || "Failed to add risk", "error");
        }
      } catch (error) {
        showToast("Failed to add risk", "error");
        console.error("Error adding risk:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  // Fetch all tasks of the organization
  useEffect(() => {
    getTasks({ organization_id: organization.current_organization.id, workStream_id: workStreamId })
      .then((response) => {
        if (response.status === 200) {
          const tasks = response.data.map((task) => ({
            id: task.id,
            name: task.title,
          }));
          setTaskList(tasks);
        }
      })
      .catch((error) => {
        showToast("Failed to fetch tasks", "error");
        console.error(error);
      });
  }, [organization?.current_organization?.id]);



  // Sync selected tasks with Formik field
  useEffect(() => {
    formik.setFieldValue(
      "task_ids",
      tasks.map((task) => task.id)
    );

    setTaskList((prevTaskList) =>
      prevTaskList.filter((task) => !tasks.find((t) => t.id === task.id))
    );
  }, [tasks]);

    const dropdownItems = [
    {
      label: 'Use a template',
      onClick: () => setShowSelectTemplateModal(true),
    },
    {
      label: 'Save as template',
      onClick: () => setShowAddTemplateModal(true),
    },
  ];

  return (
    <form onSubmit={formik.handleSubmit}>
      <ShortTextInput
        label="Title"
        type="text"
        id="title"
        name="title"
        required
        value={formik.values.title}
        onChange={formik.handleChange}
        placeholder="Enter Risk title"
        className="form-control"
        error={formik.touched.title && formik.errors.title}
      />

      {!from_goal ? (
        <div className="my-3">
          <TagDropdownInput
            label="Tasks"
            placeholder="Select Tasks"
            required
            data={taskList}
            selectedItems={tasks}
            onChange={(event, newValue) => setTasks(newValue)}
            error={formik.touched.task_ids && formik.errors.task_ids}
          />
        </div>
      ) : null}

     
      <div className="position-relative">
        <div className="position-absolute end-0 top-0 m-1">
        <CustomTemplateDropdown icon={HiOutlineDotsHorizontal}  items={dropdownItems}/>
        </div>
        <RichTextEditor
          label="Description"
          id="description"
          placeholder="Enter Risk description..."
          required
          editorValue={formik.values.description} 
          setEditorValue={(value) => formik.setFieldValue("description", value)}
          error={formik.touched.description && formik.errors.description}
        />
       </div> 

        {showSelectTemplateModal && (
        <SelectRiskTemplateModal
          show={showSelectTemplateModal}
          handleClose={() => setShowSelectTemplateModal(false)}
          handleUse={(template) => {
            formik.setFieldValue("description", template.description);
            setShowSelectTemplateModal(false);
          }
        }
        />
      )}

      {showAddTemplateModal && (
        <AddUpdateRiskTemplateModal
          show={showAddTemplateModal}
          handleClose={() => setShowAddTemplateModal(false)}
          defaultDescription={formik.values.description}
          refresh={() => {}}
        />
      )}
  

      <div className="d-flex justify-content-center gap-2 mt-4">
        <CustomButton type="button" disabled={formik.isSubmitting} onClick={() => formik.handleSubmit()}>
           {formik.isSubmitting ? "Adding..." : "Add Risk"}
        </CustomButton>
      </div>
    </form>
  );
}

export { AddNewRiskForm };
